import { TableHeadersType } from "../../../constant/tableHeadersConstants/tableHeadersType";
import { formateDateWithTime } from "../../../utils/commonFunctions";
import { BulkUploadHistoryDataType } from "../../../redux/invoiceGeneration/invoiceGenrationTypes";
import { GetGenerateSasTokenPayloadType } from "../../../commonTypes/stcoToolsType";
import { useEffect, useState } from "react";

type AppProps = {
  tableHeaders: TableHeadersType[];
  data: BulkUploadHistoryDataType[];
  token: string | null;
  sasTokenForDownloadFile: string;
  dispatchResetSasTokenForDownloadFile: () => void;
  dispatchGetTokenGenerateForDownloadAction: (
    data: GetGenerateSasTokenPayloadType
  ) => void;
};

const BulkUploadDetails = ({
    tableHeaders,
    data,
    sasTokenForDownloadFile,
    dispatchResetSasTokenForDownloadFile,
    dispatchGetTokenGenerateForDownloadAction,
    token,
 }: AppProps) => {
    const [fileName, setFileName] = useState("");
    
    const downloadBlobFile = async (file: any) => {
        setFileName(file?.file_name);
        let finalData = {
          fileUrl: file?.file_url,
          token,
          containerType: 1,
        };
        dispatchGetTokenGenerateForDownloadAction(finalData);
      };
    
    useEffect(() => {
        if (sasTokenForDownloadFile) {
          const link = document.createElement("a");
          link.href = sasTokenForDownloadFile;
          link.setAttribute("download", "");
          document.body.appendChild(link);
          link.click();
    
          document.body.removeChild(link);
          dispatchResetSasTokenForDownloadFile();
        }
      }, [sasTokenForDownloadFile]);
    
  let blobBaseUrl = process.env.REACT_APP_BLOB_BASE_URL;
  let blobToken = process.env.REACT_APP_BLOB_TOEKN;
  function isNotEmpty(obj: any) {
    return Object.keys(obj).length !== 0;
  }

  return (
    <>
      {data?.map((dataItem: any) => {
        let isProcessing = dataItem?.is_processing;
        let file = dataItem?.file;
        return (
          <tr key={dataItem?.id}>
            {tableHeaders?.length &&
              tableHeaders?.map((item: any) => {
                if (item?.value === "stage") {
                  return (
                    <td>
                      <div
                        style={{
                          color: !!isProcessing ? "#e7733e" : "#82b01f",
                          background: !!isProcessing ? "#faedd8" : "#e7f0d4",
                          width: "fit-content",
                          padding: "5px 10px",
                          borderRadius: "30px",
                        }}
                      >
                        {!!isProcessing ? "Processing" : "Ready"}
                      </div>
                    </td>
                  );
                } else if (item?.value === "file_name") {
                  return (
                    <td>{file?.file_name ? file?.file_name : " --/-- "}</td>
                  );
                } else if (item?.value === "file_url") {
                  return (
                    <td>
                      <a
                        href="#"
                        target="_blank"
                          onClick={(e) => {
                            e.preventDefault();
                            downloadBlobFile(dataItem?.file);
                          }}
                        
                      >
                        {file?.file_url && isNotEmpty(file.file_url)
                          ? file.file_url
                          : " --/-- "}
                      </a>
                    </td>
                  );
                } else if (dataItem[item.value]) {
                  return <td>{formateDateWithTime(dataItem[item.value])}</td>;
                } else {
                  return <td className="text-left"> --/-- </td>;
                }
              })}
          </tr>
        );
      })}
    </>
  );
};

export default BulkUploadDetails;
